import { CandidateReferralData } from '$types/candidates';

const RATING_COLORS = {
  high: {
    bg: 'bg-[#BFEFEC]',
    text: 'text-[#016F68]',
  },
  medium: {
    bg: 'bg-[#CFD0FF]',
    text: 'text-[#2C30D7]',
  },
  low: {
    bg: 'bg-[#FCDAC4]',
    text: 'text-[#A44101]',
  },
};

function getRatingVariant(value: number | string): keyof typeof RATING_COLORS {
  if (typeof value === 'number') {
    if (value >= 8) return 'high';
    if (value >= 5) return 'medium';
    return 'low';
  }

  switch (value) {
    case 'Excellent':
      return 'high';
    case 'Very Good':
    case 'Neutral':
      return 'medium';
    default:
      return 'low';
  }
}

const RatingBadge = ({
  label,
  value,
}: {
  label: string;
  value?: string | number | null;
}) => {
  if (value === undefined || value === null || value === '') return null;

  const variant = getRatingVariant(value);
  return (
    <div
      className={`text-[10px] py-1 px-2 rounded-md ${RATING_COLORS[variant].bg} ${RATING_COLORS[variant].text}`}
    >
      <span className="font-bold">{label}:</span>{' '}
      {typeof value === 'number' ? `${value}/10` : value}
    </div>
  );
};

RatingBadge.defaultProps = {
  value: undefined,
};

const SpkProfileReferences = ({
  references,
}: {
  references: CandidateReferralData[];
}) => {
  const referenceTemplate = (reference: CandidateReferralData) => (
    <div
      key={reference.Id}
      className="flex flex-col gap-4 p-4 rounded-2xl border border-spk-neutral-40"
    >
      <div className="flex flex-col text-spk-highContrast">
        <span className="text-sm font-bold">{reference.ReferralName}</span>
        <span className="text-xs">{reference.ReferralRelationship}</span>
      </div>

      <div className="flex flex-col gap-4 pl-3 text-spk-mediumContrast">
        <div className="flex flex-col">
          <span className="font-bold">Recommendation</span>
          <span className="whitespace-pre-wrap">
            {reference.CandidateResponsibilities}
          </span>
        </div>
        <div className="flex flex-col">
          <span className="font-bold">Job Performance</span>
          <span className="whitespace-pre-wrap">
            {reference.CandidatePerformance}
          </span>
        </div>

        <div className="flex gap-2 flex-wrap">
          <RatingBadge
            label="Likelihood to Recommend"
            value={reference.LikelihoodToRecommend}
          />
          <RatingBadge
            label="Reliability"
            value={reference.CandidateReliability}
          />
          <RatingBadge
            label="Work Ethic"
            value={reference.CandidateWorkEthic}
          />
          <RatingBadge
            label="Collaboration"
            value={reference.CandidateCollaboration}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className="flex flex-col gap-4 w-full text-sm">
      {references?.map((reference) => referenceTemplate(reference))}
    </div>
  );
};

export default SpkProfileReferences;
